export default __webpack_public_path__ + "static/media/2.02c880da.png";